import isArray from 'lodash/isArray';

export default function toArray(value: unknown) {
  if (value === undefined) {
    return [];
  }
  return isArray(value) ? value : [value];
}
